import api from '../services/api';
import { DEFAULT_IDP } from './constants';

/**
 * Checks if users email domain has IdP setup. In any other case defaults to myosh-default.
 * @param email
 * @returns domain boolean
 */

export const checkIdp = async (email: string) => {
  const domain = email.substring(email.lastIndexOf('@') + 1);
  return api
    .get(`hasCognitoIdentityProvider?domain=${domain}`)
    .then((response) => {
      if (response.data === true) {
        return domain;
      } else {
        return DEFAULT_IDP;
      }
    })
    .catch(() => DEFAULT_IDP);
};
